import { setupWorker } from "msw/browser";
import { taskHandlers } from "./handlers";

/**
 * Setup MSW service worker for browser
 */
export const worker = setupWorker(...taskHandlers);

/**
 * Starts the demo task API worker in development and published demo builds.
 *
 * @returns Completion of service-worker registration and activation
 */
export const startMockServiceWorker = async (): Promise<void> => {
  await worker.start({
    onUnhandledRequest: "bypass",
  });
};
